module.exports = __webpack_public_path__ + "static/media/bytovydom2.66383457.jpg";